<template>
  <MissionSearchPage widget />
</template>
